'use strict';

import React, { Component } from 'react';
let app = typeof window !== 'undefined' ? window.app : undefined;
export default class Auth extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement("div", {
      className: "auth-page"
    }, props.children);
    return output;
  }
}
